export const WORKOS_CLIENT_ID = import.meta.env.VITE_WORKOS_CLIENT_ID;

export const SENTRY_DSN_URL = import.meta.env.VITE_SENTRY_DSN_URL || '';

export const SERVER_URL = !import.meta.env.VITE_SERVER_URL
  ? `//${window.location.host}`
  : import.meta.env.VITE_SERVER_URL;

export const API_URL = `${SERVER_URL}/v1`;

export enum ReceiptStatus {
  inReview = 'in_review',
  enriched = 'enriched',
}
export enum ReviewStatus {
  pending = 'pending',
  processing = 'processing',
}
export enum LoyaltyActions {
  user_sign_up = 'Sign-up as a user',
  receipt_upload = 'Upload a receipt',
  user_referral = 'Submit a receipt for review',
  receipt_submit_for_review = 'Refer a user',
}
if (import.meta.env.MODE === 'development') {
  console.debug('WORKOS_CLIENT_ID', WORKOS_CLIENT_ID);
  console.debug('SERVER_URL', SERVER_URL);
  console.debug('API_URL', API_URL);
}
